
import axios from 'axios';
import Cookies from 'js-cookie';
import uuidjs from 'uuid-js';


(function setUUID() {
  const uid = Cookies.get('tracker-uid');
  if (!uid) {
    const uuidInstance = uuidjs.create(1);
    Cookies.set('tracker-uid', uuidInstance.toString(), {
      expires: 10 * 365,
      path: '/'
    });
  }
}());

function getUrlParameter(sParam) {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLconstiables = sPageURL.split('&');
  let sParameterName;
  let i;

  for (i = 0; i < sURLconstiables.length; i++) {
    sParameterName = sURLconstiables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return undefined;
}

const pattern = /(\w+)\[(\d+)\]/;
const CACHE_KEY = 'TRACKER_ID';
function getTrackerCacheId() {
  let id = localStorage.getItem(CACHE_KEY) || 0;
  return ++id;
}

function isCachceKey(key) {
  return /^TRACKER_ID_\d+/.test(key);
}

function getCacheKey(id) {
  return `${CACHE_KEY}_${id}`;
}

function decode(str) {
  try {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  } catch (e) {
    return str;
  }
}

function strParse(str) {
  if (typeof str !== 'string') return {};

  if (str === '') return {};
  if (str.charAt(0) === '?') str = str.slice(1);

  const obj = {};
  const pairs = str.split('&');
  for (let i = 0; i < pairs.length; i++) {
    const parts = pairs[i].split('=');
    const key = decode(parts[0]);
    const m = pattern.exec(key);

    if (m) {
      obj[m[1]] = obj[m[1]] || [];
      obj[m[1]][m[2]] = decode(parts[1]);
      continue;
    }

    obj[parts[0]] = parts[1] == null ? '' : decode(parts[1]);
  }

  return obj;
}

/*
  options: {
    cache: false,
    url: '/rest/teacher/api/statistics/printLog'
  }
*/
function _tracker(data, options) {
  const arr = ['partnerId', 'refereeId', 'refersourceid', 'otherpar', 'utm_campaign', 'utm_source', 'utm_medium'];
  if (!options) {
    throw new Error('必须传递options,且改方法为内部方法');
  }
  const cache = !!options.cache;
  const url = options.url || '/rest/teacher/api/statistics/printLog';
  for (let i = 0; i < arr.length; i++) {
    const el = arr[i];
    const val = getUrlParameter(el);
    if (val) {
      data[el] = val;
    }
  }
  data.referrer = window.___referrer || document.referrer || '';
  data.user_agent = window.navigator.userAgent;
  const protocol = window.location.protocol;
  const host = window.location.host;
  const pathname = window.location.pathname;
  data.url = `${protocol}//${host}${pathname}`;

  const uid = Cookies.get('tracker-uid');
  data.uid = data.uid || uid;
  // 客户端注册bug
  const userId = Cookies.get('teacherID');
  data.teacherId = window.vipkidTeacherId || userId || data.teacherId;

  if (window.location.search) {
    data.otherpar = window.location.search.substr(1);
  }

  const urlData = strParse(data.otherpar);

  data.query = urlData;

  const keys = Object.keys(data).concat(['teacherId', 'uid', 'otherpar']);
  Object.keys(urlData || {}).forEach((p) => {
    if (keys.indexOf(p) === -1) {
      data[p] = data[p] || urlData[p];
    }
  });
  const id = getTrackerCacheId();
  const cacheItemKey = getCacheKey(id);
  if (cache) {
    try {
      data.logUrl = url;
      localStorage.setItem(cacheItemKey, JSON.stringify(data));
      localStorage.setItem(CACHE_KEY, id);
    } catch (ex) {
      console.error(ex);
    } finally {
      axios.post(url, data).then(() => {
        localStorage.removeItem(cacheItemKey);
      });
    }
  } else {
    axios.post(url, data);
  }
}

setTimeout(() => {
  const allKeys = Object.keys(localStorage);
  allKeys.forEach((key) => {
    if (isCachceKey(key)) {
      const data = JSON.parse(localStorage.getItem(key));
      const logUrl = data.logUrl;
      delete data.logUrl;
      axios.post(logUrl, data).then(() => {
        localStorage.removeItem(key);
      });
    }
  });
});

_tracker({
  event: 'page_view',
}, {
  cache: false
});

// 兼容过去的版本
function tracker(data, cache) {
  _tracker(data, {
    cache
  });
}

function trackerPlus(data, options) {
  _tracker(data, options);
}
trackerPlus.create = function create(options) {
  return function bindTracker(data, _options) {
    _tracker(data, Object.assign({}, options, _options));
  };
};
const trackerParent = trackerPlus.create({
  url: '/rest/gw/teacherMobile/data/statistics/log'
});
const trackerActivity = trackerPlus.create({
  url: '/rest/tmobile/api/teacher/mobile/statistics/printLog'
});
export default tracker;
export {
  trackerPlus,
  trackerParent,
  trackerActivity
};
